/**
 * NoticeDetailContainer
 * --
 */
import React from 'react';
import NoticeDetailPresenter from './NoticeDetailPresenter';

const NoticeDetailContainer = () => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <>
      <NoticeDetailPresenter />
    </>
  );
};

export default NoticeDetailContainer;
